import React from 'react';
import './Dashboard.css';

export default function DashboardCard({ title, number, icon, extraInfo }) {
    return (
        <div className="card dashboard-card-responsive">
            <div className="card-header">
                <div className="title-section">
                    {icon}
                    <span className="card-title">{title}</span>
                </div>
                <span className="card-number">{number}</span>
            </div>
            {extraInfo && extraInfo.length > 0 && (
                <div className="extra-info">
                    {extraInfo.map((info, index) => (
                        <div key={index} className="info-item">
                            {info.icon}
                            <span className="info-number">{info.number}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}